import React from "react"
import styled from "styled-components"

const VideoContainer = styled("video-player-container")({})

const Video = styled("video")({
  width: "100%",
  height: "100%",
})

export default function VideoTrack({
  videoRef,
  userId,
  localTrack = false,
  isLocal = false,
  isMain = false,
}) {
  return localTrack ? (
    <Video
      ref={videoRef}
      style={{ transform: "rotateY(180deg)", objectFit: "cover" }}
      playsInline
      autoPlay
      muted
    />
  ) : (
    <VideoContainer
      className="video-player-container"
      id={isMain ? `${userId}-main` : userId}
      ref={videoRef}
      style={{
        transform: isLocal ? "rotateY(180deg)" : "",
        objectFit: "cover",
        with: "100%",
        height: "100%",
        aspectRatio: "unset",
      }}
    />
  )
}
